import { createContext, SetStateAction, useContext, useState } from "react";


interface PaymentContextType {
  processType: "reg" | "upd" | "conv" | ""; // reg: 口座登録, upd: ログイン情報更新, conv: 登録方式コンバート
  setProcessType: React.Dispatch<SetStateAction<"reg" | "upd" | "conv" | "">>;
}

const PaymentContext = createContext<PaymentContextType | undefined>(undefined);

export const PaymentProvider = ({children}: {children: React.ReactNode}) => {
  const [processType, setProcessType] = useState<"reg" | "upd" | "conv" | "">("");

  return (
    <PaymentContext.Provider
      value={{
        processType,
        setProcessType,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

export const usePaymentContext = () => {
  const context = useContext(PaymentContext);
  if (!context) throw new Error("PaymentContext must be used within PaymentProvider");
  return context;
};